import { Option } from '@storeblocks/radio';
import { CancelDateCategory } from 'Forms/CancelFormV2/cancelForm.constants';
import { getAppText } from 'Utils/text';
import { isDefined } from 'Utils/type.utils';
import { CancelReasonAkaHouseContents } from './cancelAkaHouseContentsForm.constants';
import { CancelAkaHouseContentsFormValues } from './cancelAkaHouseContentsForm.types';

export const shouldHaveFutureCancelDateAkaHouseContents = (
  cancelReason: unknown,
): boolean =>
  cancelReason === CancelReasonAkaHouseContents.MOVED_OR_SOLD ||
  cancelReason === CancelReasonAkaHouseContents.INSURED_VIA_UNION ||
  cancelReason === CancelReasonAkaHouseContents.INSURED_VIA_PARTNER;

export const mapCancelDateCategory = (
  values: CancelAkaHouseContentsFormValues,
): CancelDateCategory => {
  if (
    isDefined(values.cancelReason) &&
    shouldHaveFutureCancelDateAkaHouseContents(values.cancelReason)
  ) {
    return CancelDateCategory.FUTURE;
  }
  return CancelDateCategory.RENEWAL;
};

export const showFutureCancelDate = (
  values: CancelAkaHouseContentsFormValues,
): boolean =>
  isDefined(values.cancelReason) &&
  shouldHaveFutureCancelDateAkaHouseContents(values.cancelReason);

export const getAkaHouseContentsCancellationOptions = (): Option[] => [
  {
    label: getAppText('cancel.cancelReason.option.union'),
    value: CancelReasonAkaHouseContents.INSURED_VIA_UNION,
    id: 'cancelReason-1',
  },
  {
    label: getAppText('cancel.cancelReason.option.movedOrSold'),
    value: CancelReasonAkaHouseContents.MOVED_OR_SOLD,
    id: 'cancelReason-2',
  },
  {
    label: getAppText('cancel.cancelReason.option.partner'),
    value: CancelReasonAkaHouseContents.INSURED_VIA_PARTNER,
    id: 'cancelReason-3',
  },
  {
    label: getAppText('cancel.cancelReason.option.renewal'),
    value: CancelReasonAkaHouseContents.NOT_IN_NEED,
    id: 'cancelReason-4',
  },
];
